import { createFileRoute } from "@tanstack/react-router";
import * as v from "valibot";
import { BidraView } from "@/lib/features/BidraView";
import { bidraSearchSchema } from "@/lib/schemas/searchParams.schema";
export const Route = createFileRoute("/_app/bidra")({
  component: BidraView,
  validateSearch: search => v.parse(bidraSearchSchema, search)
});